import MOMENTJS_DATE_FORMATES from "@/common/constants/momentjs-format";
import dayjs, { Dayjs } from "dayjs";

export const getTimeStops = (
  date: string,
  start: string,
  end: string,
  duration = 20
): string[] => {
  let startTime: Dayjs = dayjs(`${date} ${start}`, MOMENTJS_DATE_FORMATES.toDateTimeWithoutss);
  let endTime: Dayjs = dayjs(`${date} ${end}`, MOMENTJS_DATE_FORMATES.toDateTimeWithoutss);

  // console.log('startTime-->',startTime.format(MOMENTJS_DATE_FORMATES.toDateTimeWithoutss));
  // console.log('dayjs-->',dayjs().format(MOMENTJS_DATE_FORMATES.toDateTimeWithoutss));
  // console.log('startTime.isBefore(dayjs())-->', startTime.isBefore(dayjs()));
  // // if(startTime.isBefore(dayjs())) {
  // //   return [];
  // // }

  if (endTime.isBefore(startTime)) {
    endTime.add(1, "day");
  }

  let timeStops: string[] = [];

  while (startTime.clone().add(duration, "minutes") <= endTime) {
    timeStops.push(startTime.format(MOMENTJS_DATE_FORMATES.toTime));
    startTime = startTime.clone().add(duration, "minutes");
  }

  return timeStops;
};